'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fdrug$package$DrugStrength$() {
  this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_defaultMake$lzy4 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_defaultMakebitmap$4 = false;
  this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_make$lzy4 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_makebitmap$4 = false;
  this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_given_Show_Type$lzy4 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_given_Show_Typebitmap$4 = false;
  this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_validator = null;
  this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_given_LocalizedTextOf_Type$lzy5 = null;
  this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_given_LocalizedTextOf_Typebitmap$5 = false;
  $n_Lapp_data_types\uff3fdrug$package$DrugStrength$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validator$();
  var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_IArray$package$IArray$();
  var arr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_NewtypeNonEmptyString$().Lframework_utils_NewtypeNonEmptyString$__f_validators;
  var suffix = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lyantl_ValidatorRule.getArrayOf().constr)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lyantl_ValidatorRule$().maxLength__I__Lyantl_ValidatorRule(100)]);
  var this$5 = this$3.genericWrapArray__O__sci_ArraySeq(suffix);
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  capacity = 0;
  size = 0;
  jsElems = [];
  var delta = arr.u.length;
  this$5.length__I();
  var length = arr.u.length;
  var i = 0;
  while ((i < length)) {
    var x1$1 = i;
    var elem = arr.u[x1$1];
    var unboxedElem = ((elem === null) ? null : elem);
    jsElems.push(unboxedElem);
    i = ((1 + i) | 0);
  }
  var it = this$5.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem$1 = it.next__O();
    var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
    jsElems.push(unboxedElem$1);
  }
  var x = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lyantl_ValidatorRule.getArrayOf().constr)(jsElems);
  this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validator$().fromRules__ALyantl_ValidatorRule__Lyantl_Validator(x);
}
export { $c_Lapp_data_types\uff3fdrug$package$DrugStrength$ as $c_Lapp_data_types\uff3fdrug$package$DrugStrength$ };
$c_Lapp_data_types\uff3fdrug$package$DrugStrength$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fdrug$package$DrugStrength$.prototype.constructor = $c_Lapp_data_types\uff3fdrug$package$DrugStrength$;
/** @constructor */
function $h_Lapp_data_types\uff3fdrug$package$DrugStrength$() {
}
export { $h_Lapp_data_types\uff3fdrug$package$DrugStrength$ as $h_Lapp_data_types\uff3fdrug$package$DrugStrength$ };
$h_Lapp_data_types\uff3fdrug$package$DrugStrength$.prototype = $c_Lapp_data_types\uff3fdrug$package$DrugStrength$.prototype;
$c_Lapp_data_types\uff3fdrug$package$DrugStrength$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_defaultMakebitmap$4)) {
    this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_defaultMake$lzy4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_defaultMakebitmap$4 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_defaultMake$lzy4;
});
$c_Lapp_data_types\uff3fdrug$package$DrugStrength$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_makebitmap$4)) {
    this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_make$lzy4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_makebitmap$4 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_make$lzy4;
});
$c_Lapp_data_types\uff3fdrug$package$DrugStrength$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fdrug$package$DrugStrength$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fdrug$package$DrugStrength$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fdrug$package$DrugStrength$.prototype.given_Show_Type__Lcats_Show = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_given_Show_Typebitmap$4)) {
    this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_given_Show_Type$lzy4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_given_Show_Typebitmap$4 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_given_Show_Type$lzy4;
});
$c_Lapp_data_types\uff3fdrug$package$DrugStrength$.prototype.validate__Lyantl_Validate = (function() {
  return this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_validator;
});
$c_Lapp_data_types\uff3fdrug$package$DrugStrength$.prototype.given_LocalizedTextOf_Type__Lframework_localization_LocalizationSupport$LocalizedTextOf = (function() {
  if ((!this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_given_LocalizedTextOf_Typebitmap$5)) {
    var this$1 = $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().LocalizedTextOf__Lframework_localization_LocalizationSupport$LocalizedTextOf$();
    var localize = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Strength";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    }));
    this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_given_LocalizedTextOf_Type$lzy5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_localization_LocalizationSupport$$anon$5(localize, this$1);
    this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_given_LocalizedTextOf_Typebitmap$5 = true;
  }
  return this.Lapp_data_types\uff3fdrug$package$DrugStrength$__f_given_LocalizedTextOf_Type$lzy5;
});
var $d_Lapp_data_types\uff3fdrug$package$DrugStrength$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fdrug$package$DrugStrength$, "app.data.types_drug$package$DrugStrength$", ({
  Lapp_data_types\uff3fdrug$package$DrugStrength$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_utils_NewtypeString: 1,
  Lyantl_Newtype$ValidatedOf: 1
}));
export { $d_Lapp_data_types\uff3fdrug$package$DrugStrength$ as $d_Lapp_data_types\uff3fdrug$package$DrugStrength$ };
var $n_Lapp_data_types\uff3fdrug$package$DrugStrength$;
function $m_Lapp_data_types\uff3fdrug$package$DrugStrength$() {
  if ((!$n_Lapp_data_types\uff3fdrug$package$DrugStrength$)) {
    $n_Lapp_data_types\uff3fdrug$package$DrugStrength$ = new $c_Lapp_data_types\uff3fdrug$package$DrugStrength$();
  }
  return $n_Lapp_data_types\uff3fdrug$package$DrugStrength$;
}
export { $m_Lapp_data_types\uff3fdrug$package$DrugStrength$ as $m_Lapp_data_types\uff3fdrug$package$DrugStrength$ };
//# sourceMappingURL=app.data.types_drug$package$-Drug-Strength$.js.map
